import { useParams } from "common";
export const useProjectDetailsParams = useParams;